'use strict';

var _ = require('../dependency')._,
    config = require('../config'),
    $u = require('../utilities');

var GRAPHS = config.graphs;

var chartId = 'CUSTOMER_BY_SSID_COUNT',
    chartType = 'POINT_IN_TIME',
    filters = [config.filters.DATE],
    dataSeries = {
        SSID_COUNT: 'ssidCount'
    },
    fieldNames = {
        SSID_PROFILE_COUNT: 'amcNumOfSsidProfileBeingUsedInTemplates'
    },
    /**
     * [dataConfig The query params to pass to the API http endpoint POST. Currently this are specific to druid querying.
     * can be modified for other data provider systems.]
     * @type {Object}
     */
    dataConfig = [{
        queryType: 'groupBy',
        /*!ToDo above use this from druid settings object (settings maybe in matrix charts)*/
        dataSource: 'babbage',
        /*above Can be set in library matrix charts*/
        dimensions: ['customer'],
        aggregations: [{
            type: 'longSum',
            name: dataSeries.SSID_COUNT,
            fieldName: fieldNames.SSID_PROFILE_COUNT
        }]
    }],
    dataSeriesFields = ['ssidCountBuckets', 'ssidCount'],
    modelFieldKeys = $u.charts.generateFieldKeysArray(dataConfig, dataSeriesFields),
    tasks = [
        'durationFilter',
        'druidQueryGenerator',
        'druidQueryValidator',
        'fetchChartData',
        'druidResponseParser', {
            name: 'afterApiBucketFields',
            config: {
                seriesToBucket: [dataSeries.SSID_COUNT],
                buckets: GRAPHS.CHART_METADATA.CUSTOMER_SSID_COUNT.BUCKETS,
                createLastBucket: true,
                lastBucketPrefix: 'Greater than ',
                returnEmptyBuckets: true
            }
        }, {
            plugin: modifyResponse
        }, {
            name: 'updateChartModelData',
            config: {
                dataSeriesFields: dataSeriesFields,
                modelFieldKeys: modelFieldKeys
            }
        }
    ];

exports.chartId = chartId;
exports.chartType = chartType;
exports.dataSeries = dataSeries;
exports.fieldNames = fieldNames;
exports.filters = filters;
exports.dataConfig = dataConfig;
exports.dataSeriesFields = dataSeriesFields;
exports.modelFieldKeys = modelFieldKeys;
exports.tasks = tasks;
exports.chartTemplate = chartTemplate;
exports.i18n = config.graphs.CHART_METADATA.CUSTOMER_SSID_COUNT;

function modifyResponse(context, config, next) {
    var model = context.apiMergedResponse,
        computedModel = {};
    model[dataSeries.SSID_COUNT].None = model[dataSeries.SSID_COUNT]['0'];
    delete model[dataSeries.SSID_COUNT]['0'];
    computedModel.ssidCountBuckets = _.keys(model[dataSeries.SSID_COUNT]);
    computedModel.ssidCount = _.values(model[dataSeries.SSID_COUNT]);

    if ($u.charts.allEqualElemArray(computedModel.ssidCount, 0) ||
        $u.charts.allEqualElemArray(computedModel.ssidCount, null)
    ) {
        context.zeroDataFlag = true;
    }

    context.chartData = computedModel;
    next();
}

function chartTemplate(data, width) {
    width = parseInt(width.match(/\d+/g)[0], 10);
    var legendAdjustments = $u.charts.getLegendAdjustments(data.__duration, false, false);

    var yAxisFormatter = $u.charts.chartYaxisFormatter,
        yAxisBaseUnit = '',
        yAxisRoundOff = false,
        yAxisTrimDecimalPlaces = 2,
        nameHeader = 'No. of SSIDs',
        yHeader = 'No. Of Customers',
        percentageHeader = '% of Customers';

    var chartTemplateObj = {
        dataTableConfig: {
            customDateString: data.__generationDateString,
            yAxisFormatter: yAxisFormatter,
            yAxisBaseUnit: yAxisBaseUnit,
            yAxisRoundOff: yAxisRoundOff,
            nameHeader: nameHeader,
            yHeader: yHeader,
            yAxisTrimDecimalPlaces: yAxisTrimDecimalPlaces,
            percentageHeader: percentageHeader
        },
        isPie: true,
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            marginTop: GRAPHS.GLOBAL.CHART_MARGINS.TOP,
            marginBottom: GRAPHS.GLOBAL.CHART_MARGINS.BOTTOM
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function() {
                var currentContext = this,
                    yMax = _.max(currentContext.series.yData),
                    yValue = currentContext.y,
                    yTooltipUnitObj = yAxisFormatter(yValue, yMax,
                        yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces);

                return $u.charts.sformat('{0}: <b>{1}</b><br />{2}: <b>{3} {4}</b>',
                    nameHeader,
                    currentContext.point.name,
                    yHeader,
                    yTooltipUnitObj.value,
                    yTooltipUnitObj.unit
                );
            },
            percentageDecimals: 0
        },
        subtitle: {
            text: ''
        },
        legend: {
            y: legendAdjustments.y,
            itemDistance: legendAdjustments.itemDistance,
            itemStyle: {
                fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
            }
        },
        plotOptions: {
            pie: {
                size: 150,
                center: ['50%', '65%'],
                allowPointSelect: true,
                cursor: 'pointer',
                showInLegend: true,
                colors: [
                    GRAPHS.GLOBAL.COLORS.CHART_GREEN,
                    GRAPHS.GLOBAL.COLORS.MOJO_BLUE,
                    GRAPHS.GLOBAL.COLORS.MOJO_RED,
                    GRAPHS.GLOBAL.COLORS.MOJO_PURPLE,
                    GRAPHS.GLOBAL.COLORS.CHART_RED,
                    GRAPHS.GLOBAL.COLORS.MOJO_TEAL
                ],
                dataLabels: {
                    enabled: true,
                    crop: false,
                    distance: width / 50,
                    style: {
                        fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                    },
                    connectorColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
                    formatter: function() {
                        if (0 !== this.y)
                            return '<b>' + this.point.name + '</b>: ' + this.percentage.toFixed(2) + ' %';
                    }
                },
                point: {
                    events: {
                        legendItemClick: function() {
                            return false;
                        }
                    }
                }
            }
        },
        series: [{
            name: 'SSID distribution for customers',
            type: 'pie',
            data: _.map(_.range(data.ssidCount.length), function(index) {
                return {
                    name: data.ssidCountBuckets[index],
                    y: data.ssidCount[index]
                };
            })
        }]
    };
    chartTemplateObj = _.assign({}, config.defaultSettings, chartTemplateObj);
    return chartTemplateObj;
}
